export enum LoginRedirectPage {
	MyWork = 1,
	SiteNotes = 2,
	Deficiencies = 3,
	ManageDocuments = 4,
	DeleteAccount = 5,
}
